// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indicator-overlay-wrapper .overlay[data-v-553eb051]{position:absolute;top:0;bottom:0;left:0;right:0;background:#000;opacity:.4;z-index:99;pointer-events:bounding-box}.indicator-overlay-wrapper .indicator-wrapper[data-v-553eb051]{position:absolute;left:50%;top:50%;margin-left:-35px;margin-top:-35px;z-index:100}", ""]);
// Exports
module.exports = exports;
